module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray-81e35da77aba6be1ca7e62396b67bf39.png";